import Grid from '@material-ui/core/Grid'
import {Trans} from 'react-i18next'
import messages from '../../assets/messages'
import Loading from '../Common/Loading'
import PageSubTitle from '../Common/PageSubTitle'
import {PammOffersTree} from '../PammOffersTree'
import {usePammAgentOffers} from './usePammAgentOffers'

/**
 * Agent-facing PAMM offers page (reached via the "PAMM Agent Offers" sidebar menu).
 *
 * Renders the agent's own offer together with its full downline as a hierarchical,
 * expandable tree (PT-5399).
 */
export const PammAgentOffers = () => {
  const {error, pammAgentOffers, loading} = usePammAgentOffers()
  if (error) return <pre>{JSON.stringify(error)}</pre>
  if (loading) return <Loading />

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageSubTitle>
          <Trans {...messages.pammAgentOffers} />
        </PageSubTitle>
      </Grid>
      <Grid item xs={12}>
        <PammOffersTree offers={pammAgentOffers} />
      </Grid>
    </Grid>
  )
}
